import { type SanityGalleryModule } from '@data/sanity/queries/types/modules'

import ContentCarousel from '@blocks/content-carousel'

type GalleryProps = Pick<SanityGalleryModule, 'title' | 'items'>

const Gallery = ({ title, items }: GalleryProps) => {
  return (
    <section className="bg-brown text-orange">
      <div className="container py-12 sm:py-16 md:py-24 lg:py-32">
        {title && <h4 className="mb-4">{title}</h4>}
        <ContentCarousel items={items} />
      </div>
    </section>
  )
}

export default Gallery
